import { UserGroups } from '@/types'
import { ROUTES_PATH_PARTS } from '@/constants'

export type NavigationItemType = {
  href: string
  title: string
  group?: UserGroups[]
}

export const navigationItems = [
  {
    href: '/',
    title: 'menu.projects',
    group: [UserGroups.MANAGER, UserGroups.CLIENT],
  },
  {
    href: '/quotations',
    title: 'menu.quotations',
    group: [UserGroups.MANAGER],
  },
  {
    href: '/planning',
    title: 'menu.planning',
    group: [UserGroups.MANAGER],
  },
  {
    href: '/monitoring',
    title: 'menu.monitoring',
    group: [UserGroups.MANAGER],
  },
  {
    href: '/data-validation',
    title: 'menu.dataValidation',
    group: [
      UserGroups.MANAGER,
      UserGroups.EMPLOYEE,
      UserGroups.CLIENT,
      UserGroups.DATA_CONTROLLER,
    ],
  },
  {
    href: '/observation-logs',
    title: 'menu.observationLogs',
    group: [
      UserGroups.MANAGER,
      UserGroups.EMPLOYEE,
      UserGroups.SOUND_TECHNICIAN,
      UserGroups.CLIENT,
      UserGroups.DATA_CONTROLLER,
    ],
  },
  {
    href: '/sound-records',
    title: 'menu.soundRecords',
    group: [UserGroups.SOUND_TECHNICIAN],
  },
  {
    href: '/hours-reporting',
    title: 'menu.hoursReporting',
    group: [UserGroups.HR],
  },
  {
    href: '/manual-hours-reporting',
    title: 'menu.manualHoursReporting',
    group: [
      UserGroups.EMPLOYEE,
      UserGroups.MANAGER,
      UserGroups.HR,
      UserGroups.DATA_CONTROLLER,
      UserGroups.SOUND_TECHNICIAN,
    ],
  },
  {
    href: `/${ROUTES_PATH_PARTS.EXPENSES_DECLARATION}`,
    title: 'menu.expensesDeclaration',
    group: [UserGroups.HR],
  },
  {
    href: `/${ROUTES_PATH_PARTS.HR_INTERNAL_HOURS}`,
    title: 'menu.hrInternalHours',
    group: [UserGroups.HR],
  },
] as NavigationItemType[]
